<template>
  <div class="kbo-zzim">
    <button v-if="alarmYn === 'Y'" class="kbo-zzim-button">
      <img src="../../assets/images/kbo/icon-alart-on.png" alt="시청 예약">
    </button>
    <button v-else class="kbo-zzim-button">
      <img src="../../assets/images/kbo/icon-alart-off.png" alt="시청 예약 취소">
    </button>
  </div>
</template>
<script>
  export default {
    componentName: 'BaseballAlarm',
    props: {
      alarmYn: {
        type: String
      }
    }
  }
</script>
